
import { DashboardHeader } from "@/components/admin/DashboardHeader";
import { DashboardMetrics } from "@/components/admin/DashboardMetrics";
import { AdminTools } from "@/components/admin/AdminTools";
import { useUserProfile } from "@/hooks/useUserProfile";
import { useDashboardMetrics } from "@/hooks/useDashboardMetrics";

export default function Admin() {
  const { isLoading, isAdmin, userPlan } = useUserProfile();
  const { data: metrics, isLoading: isMetricsLoading } = useDashboardMetrics(isAdmin, isLoading);

  const isPageLoading = isLoading || isMetricsLoading;

  return (
    <div className="space-y-8">
      <DashboardHeader userPlan={userPlan} />
      <DashboardMetrics metrics={metrics} isLoading={isPageLoading} />
      {isAdmin && <AdminTools />}
    </div>
  );
}
